module.exports = __webpack_public_path__ + "static/media/8.6de38b0f.jpg";